import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuthStore } from "@/store/auth.store";
import type { UserRole } from "@/types";

export function RequireRole({ roles }: { roles: UserRole[] }) {
  const location = useLocation();
  const role = useAuthStore((state) => state.role);
  if (roles.includes(role)) return <Outlet />;
  return <Navigate to="/login" state={{ from: location.pathname }} replace />;
}
